import { FileDownload } from '@mui/icons-material';
import { Button, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import { StationsPageControlsProps } from './StationsPageControls.types';

/**
 * Renders control panel for stations page with sorting, filtering, and export
 */
export const StationsPageControls = ({
  sortBy,
  brandFilter,
  availableBrands,
  isMobile,
  onSortChange,
  onBrandChange,
  onExport,
  exportButtonClass = '',
  showExport = true
}: StationsPageControlsProps) => {
  return (
    <div className="controls-section">
      <FormControl size="small" className="sort-control">
        <InputLabel>Сортування</InputLabel>
        <Select value={sortBy} onChange={onSortChange} label="Сортування">
          <MenuItem value="alphabetical">По алфавіту</MenuItem>
          <MenuItem value="bindings">По прив'язкам</MenuItem>
        </Select>
      </FormControl>

      <FormControl size="small" className="brand-control">
        <InputLabel>Бренд</InputLabel>
        <Select value={brandFilter} onChange={onBrandChange} label="Бренд">
          <MenuItem value="">Всі</MenuItem>
          {availableBrands.map((brand: any) => (
            <MenuItem key={brand.id} value={brand.name}>
              {brand.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {showExport && (
        <Button startIcon={<FileDownload />} onClick={onExport} className={exportButtonClass}>
          {!isMobile ? 'Експорт' : ''}
        </Button>
      )}
    </div>
  );
};
